module.exports = __webpack_public_path__ + "static/img/loginbg.d9cbf46.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/zlkindex/loginbg.jpg
// module id = kkWn
// module chunks = 1